import { User, Activity, Target, Shirt, CheckCircle } from 'lucide-react';

export const STEPS = ['stepIdentity', 'stepMorphology', 'stepGoals', 'stepStyle', 'stepConfirm'];
export const STEP_ICONS = [User, Activity, Target, Shirt, CheckCircle];

export const GOALS_OPTIONS = ['dating', 'career', 'confidence', 'social_media', 'health', 'style_goal'];
export const FITNESS_LEVELS = ['sedentary', 'light', 'moderate', 'active', 'athlete'];
export const MORPHOLOGIES = ['ectomorph', 'mesomorph', 'endomorph'];
export const FACE_SHAPES = ['oval', 'round', 'square', 'heart', 'oblong'];
export const SKIN_TYPES = ['normal', 'dry', 'oily', 'combination', 'sensitive'];
export const SKIN_TONES = ['very_fair', 'fair', 'medium', 'olive', 'dark', 'very_dark'];
export const BUDGETS = ['low', 'med', 'high', 'premium'];

export const STYLE_OPTIONS = [
  { value: 'casual', label: 'Casual' },
  { value: 'streetwear', label: 'Streetwear' },
  { value: 'smart_casual', label: 'Smart Casual' },
  { value: 'business', label: 'Business' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'sporty', label: 'Sporty' },
];

export const groomingOptions = (language) => ([
  { value: 'minimal', label: 'Minimal' },
  { value: 'basic', label: language === 'fr' ? 'Basique' : 'Basic' },
  { value: 'moderate', label: language === 'fr' ? 'Mod\u00e9r\u00e9' : 'Moderate' },
  { value: 'detailed', label: language === 'fr' ? 'D\u00e9taill\u00e9' : 'Detailed' },
  { value: 'premium', label: 'Premium' },
]);

export const EMPTY_PROFILE = {
  age: '', height: '', weight: '',
  morphology: '', face_shape: '', skin_type: '', skin_tone: '',
  current_style: '', budget: '', constraints: '',
  goals: [], grooming_habits: '', fitness_level: '',
};

/** Cast numeric text inputs to integers before sending to the API. */
export const normalizeProfile = (profile) => {
  const clean = { ...profile };
  ['age', 'height', 'weight'].forEach((key) => {
    if (clean[key] !== '' && clean[key] != null) clean[key] = parseInt(clean[key], 10);
  });
  return clean;
};
